import { Agency, AgencyCategory, AgencyAbbr, JogId, AgencyId } from ".";
import { WspDistrcitFilterLabel, WspDistrictFilterKey } from "./wsp";

const makeFakeAgency = (jogIds: JogId[], id: WspDistrictFilterKey, name: string, shortName: string, category: AgencyCategory): Agency => {
  return {
    abbreviation: id as AgencyAbbr,
    shortName,
    category,
    createdBy: "SYSTEM",
    createdDate: (new Date()).toISOString(),
    id: id as AgencyId,
    name,
    jogIds: jogIds,
    isUserAgency: false,
    isFilter: true,
    isFake: true,
  };
}

const d1JogIds = [JogId.Wsp, JogId.Tacoma, JogId.JBLM];
const d2JogIds = [JogId.Wsp, JogId.SeattleArea, JogId.KingCountyNortheast, JogId.KingCountySouth, JogId.SnohomishCounty];
const d3JogIds = [JogId.Wsp, JogId.EasternWashington]
const d4JogIds = [JogId.Wsp, JogId.EasternWashington];
const d5JogIds = [JogId.Wsp, JogId.ClarkCounty, JogId.LowerColumbiaRiver];
const d6JogIds = [JogId.Wsp, JogId.EasternWashington];
const d7JogIds = [JogId.Wsp, JogId.NorthwestWashington, JogId.SnohomishCounty];
const d8JogIds = [JogId.Wsp, JogId.LowerColumbiaRiver, JogId.KitsapPeninsula];

// sanitizeJogIdsForEvents relies on this being ordered by district number.
export const WspDistrictJogs = [d1JogIds, d2JogIds, d3JogIds, d4JogIds, d5JogIds, d6JogIds, d7JogIds, d8JogIds];

// When the "WSP" group is selected, we need to include a minimum set of JOG IDs that will work to retrieve all WSP events.
// When a district is associated with multiple JOGs, we only need to include one of those JOG IDs.
export const MinWspDistrictJogIdsMap = new Map<Number, JogId>([
  [1, JogId.Tacoma], // "04"

  [2, JogId.SnohomishCounty], // "06"
  [7, JogId.SnohomishCounty],

  [5, JogId.LowerColumbiaRiver], // "11"
  [8, JogId.LowerColumbiaRiver],

  [3, JogId.EasternWashington], // "18"
  [4, JogId.EasternWashington],
  [6, JogId.EasternWashington],
]);

export const WspFakeAgencies: Agency[] = [
  makeFakeAgency(d1JogIds, WspDistrictFilterKey.TAC_D1, "Washington State Patrol (District 1)", WspDistrcitFilterLabel.TAC_D1, AgencyCategory.LawEnforcement),
  makeFakeAgency(d2JogIds, WspDistrictFilterKey.SEA_D2, "Washington State Patrol (District 2)", WspDistrcitFilterLabel.SEA_D2, AgencyCategory.LawEnforcement),
  makeFakeAgency(d3JogIds, WspDistrictFilterKey.YAK_D3, "Washington State Patrol (District 3)", WspDistrcitFilterLabel.YAK_D3, AgencyCategory.LawEnforcement),
  makeFakeAgency(d4JogIds, WspDistrictFilterKey.SPO_D4, "Washington State Patrol (District 4)", WspDistrcitFilterLabel.SPO_D4, AgencyCategory.LawEnforcement),
  makeFakeAgency(d5JogIds, WspDistrictFilterKey.VAN_D5, "Washington State Patrol (District 5)", WspDistrcitFilterLabel.VAN_D5, AgencyCategory.LawEnforcement),
  makeFakeAgency(d6JogIds, WspDistrictFilterKey.WEN_D6, "Washington State Patrol (District 6)", WspDistrcitFilterLabel.WEN_D6, AgencyCategory.LawEnforcement),
  makeFakeAgency(d7JogIds, WspDistrictFilterKey.NW_D7, "Washington State Patrol (District 7)", WspDistrcitFilterLabel.NW_D7, AgencyCategory.LawEnforcement),
  makeFakeAgency(d8JogIds, WspDistrictFilterKey.PEN_D8, "Washington State Patrol (District 8)", WspDistrcitFilterLabel.PEN_D8, AgencyCategory.LawEnforcement),
];